export const formatObjectToQueryString = (queryParams: any): string => {
    return Object.entries(queryParams)
        .map(([key, value]) => {
            if (Array.isArray(value)) {
                return value.map((v) => `${key}=${encodeURIComponent(v)}`).join('&');
            }
            return `${key}=${encodeURIComponent(value as string)}`;
        })
        .join('&');
};
